/*
 * @Date: 2022-07-04 17:34:53
 * @LastEditors: chuhongguang
 */
export default {
  title: 'Environment, Social and Governance',
  desc: `'Our group adheres to the mission of "making it easy for enterprises to work" and takes "serving customers better" as the core. We are committed to helping enterprises realize asset transformation, truly realizing cost reduction and efficiency increase.'`
}